import { render } from "./announcements_page.vue?vue&type=template&id=761df8ea"
import script from "./announcements_page.js?vue&type=script&lang=js"
export * from "./announcements_page.js?vue&type=script&lang=js"

import "./announcements_page.vue?vue&type=style&index=0&id=761df8ea&lang=scss"

import exportComponent from "/Users/lainsoykaf/repos/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__